// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"VkTW8","filter-wrapper":"jxpLF","header":"KGNGV","footer":"ljeEY","overlay":"gw-Ss","active":"MMdMD","slide-in":"xrjBY","inactive":"gTREN","slide-out":"bes6X"};